import Accordion from "react-bootstrap/Accordion";
import { CustomAccordionItem } from "types/accordion/CustomAccordionItemType";
import AccordionButton from "react-bootstrap/AccordionButton";
import { useStyles } from "./AccordionDespesaStyles";

interface AccordionDespesaProps {
  itens: CustomAccordionItem[];
  keyItemAtivoPorPadrao?: string;
  permitirVariosItensAtivos?: boolean;
}

export const AccordionDespesa: React.FC<AccordionDespesaProps> = (props) => {
  const classes = useStyles();
  const renderAccordionItems = () => {
    const accordionItems = props.itens;

    return accordionItems.map((item: CustomAccordionItem) => {
      return (
        <Accordion.Item className={classes.accordionItem} eventKey={item.key} key={item.key}>
          <AccordionButton className={classes.header}>
            <div className={classes.iconContainer}>{item.icon ? item.icon : null}</div>

            <div className={classes.titleContainer}>
              <span className={classes.title}>{item.titulo}</span>
              <div className="botoes-accordions">{item.botoes && item.botoes.map((botao) => botao)}</div>
            </div>
          </AccordionButton>
          <Accordion.Body className={classes.body}>{item.conteudo}</Accordion.Body>
        </Accordion.Item>
      );
    });
  };

  return (
    <Accordion
      className={classes.accordion}
      alwaysOpen={props.permitirVariosItensAtivos}
      defaultActiveKey={props.keyItemAtivoPorPadrao}
    >
      {renderAccordionItems()}
    </Accordion>
  );
};

export default AccordionDespesa;
